module.exports = __webpack_public_path__ + "media/promo/velle/images/background-2518e2b5181d373154640b8d6cf216d1.png";